import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    constructor(
        private matSnackBar: MatSnackBar,
        private http: HttpClient,
    ) {}

    downloadAssets(assetIds: string[]) {
        if (assetIds.length === 0) {
            return;
        }

        const snackBar = this.matSnackBar.open('Preparing download...', null, { duration: 0 });

        const url = `/api/asset/download/`;
        const data = {
            asset_ids: assetIds,
        };
        const options = {
            withCredentials: true,
            responseType: 'blob' as 'json',
        };
        this.http.post(url, data, options).subscribe((result) => {
            const blob = new Blob([result as any], { type: 'application/octetstream' });
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = 'assets.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(a.href);

            snackBar.dismiss();
        });
    }
}
